var map = {
	"./AC.svg": 34021,
	"./AD.svg": 26842,
	"./AE.svg": 20715,
	"./AF.svg": 62648,
	"./AG.svg": 88009,
	"./AI.svg": 72863,
	"./AL.svg": 12674,
	"./AM.svg": 16403,
	"./AO.svg": 69777,
	"./AQ.svg": 59719,
	"./AR.svg": 95156,
	"./AS.svg": 33141,
	"./AT.svg": 4042,
	"./AU.svg": 72859,
	"./AW.svg": 53337,
	"./AX.svg": 52894,
	"./AZ.svg": 70620,
	"./BA.svg": 54378,
	"./BB.svg": 45753,
	"./BD.svg": 53191,
	"./BE.svg": 89366,
	"./BF.svg": 61237,
	"./BG.svg": 4980,
	"./BH.svg": 21763,
	"./BI.svg": 7122,
	"./BJ.svg": 257,
	"./BL.svg": 30607,
	"./BM.svg": 86878,
	"./BN.svg": 41053,
	"./BO.svg": 51580,
	"./BQ.svg": 5466,
	"./BR.svg": 73577,
	"./BS.svg": 69336,
	"./BT.svg": 58519,
	"./BV.svg": 66565,
	"./BW.svg": 15396,
	"./BY.svg": 21922,
	"./BZ.svg": 42289,
	"./CA.svg": 25993,
	"./CC.svg": 72491,
	"./CD.svg": 67812,
	"./CF.svg": 96550,
	"./CG.svg": 10935,
	"./CH.svg": 58752,
	"./CI.svg": 94705,
	"./CK.svg": 79507,
	"./CL.svg": 45612,
	"./CM.svg": 44557,
	"./CN.svg": 96206,
	"./CO.svg": 24639,
	"./CP.svg": 16424,
	"./CR.svg": 6794,
	"./CU.svg": 13653,
	"./CV.svg": 41782,
	"./CW.svg": 5607,
	"./CX.svg": 17136,
	"./CY.svg": 52673,
	"./CZ.svg": 59538,
	"./DE.svg": 12088,
	"./DG.svg": 48218,
	"./DJ.svg": 14975,
	"./DK.svg": 86542,
	"./DM.svg": 49088,
	"./DO.svg": 64674,
	"./DZ.svg": 73359,
	"./EA.svg": 47291,
	"./EC.svg": 47673,
	"./EE.svg": 3527,
	"./EG.svg": 76949,
	"./EH.svg": 39666,
	"./ER.svg": 13784,
	"./ES-CT.svg": 79951,
	"./ES-GA.svg": 87590,
	"./ES.svg": 89289,
	"./ET.svg": 46054,
	"./EU.svg": 8855,
	"./FI.svg": 98470,
	"./FJ.svg": 34693,
	"./FK.svg": 56676,
	"./FM.svg": 99770,
	"./FO.svg": 66200,
	"./FR.svg": 26013,
	"./GA.svg": 18429,
	"./GB-ENG.svg": 50237,
	"./GB-NIR.svg": 75698,
	"./GB-SCT.svg": 52647,
	"./GB-WLS.svg": 71085,
	"./GB.svg": 64254,
	"./GD.svg": 60944,
	"./GE.svg": 73185,
	"./GF.svg": 84498,
	"./GG.svg": 22435,
	"./GH.svg": 66004,
	"./GI.svg": 7989,
	"./GL.svg": 34056,
	"./GM.svg": 41977,
	"./GN.svg": 81226,
	"./GP.svg": 13100,
	"./GQ.svg": 92813,
	"./GR.svg": 63694,
	"./GS.svg": 68447,
	"./GT.svg": 26240,
	"./GU.svg": 72689,
	"./GW.svg": 80787,
	"./GY.svg": 13317,
	"./HK.svg": 22338,
	"./HM.svg": 3500,
	"./HN.svg": 82527,
	"./HR.svg": 82523,
	"./HT.svg": 42805,
	"./HU.svg": 4820,
	"./IC.svg": 50717,
	"./ID.svg": 16786,
	"./IE.svg": 31427,
	"./IL.svg": 64042,
	"./IM.svg": 24411,
	"./IN.svg": 73672,
	"./IO.svg": 55417,
	"./IQ.svg": 81887,
	"./IR.svg": 2860,
	"./IS.svg": 1805,
	"./IT.svg": 31586,
	"./JE.svg": 5870,
	"./JM.svg": 6214,
	"./JO.svg": 77476,
	"./JP.svg": 83843,
	"./KE.svg": 92925,
	"./KG.svg": 43407,
	"./KH.svg": 85256,
	"./KI.svg": 67001,
	"./KM.svg": 96277,
	"./KN.svg": 83318,
	"./KP.svg": 22976,
	"./KR.svg": 83138,
	"./KW.svg": 35999,
	"./KY.svg": 8617,
	"./KZ.svg": 66682,
	"./LA.svg": 71068,
	"./LB.svg": 33743,
	"./LC.svg": 71166,
	"./LI.svg": 41684,
	"./LK.svg": 73654,
	"./LR.svg": 26335,
	"./LS.svg": 88398,
	"./LT.svg": 53873,
	"./LU.svg": 13312,
	"./LV.svg": 4051,
	"./LY.svg": 13924,
	"./MA.svg": 56467,
	"./MC.svg": 6289,
	"./MD.svg": 40814,
	"./ME.svg": 78751,
	"./MF.svg": 99724,
	"./MG.svg": 35181,
	"./MH.svg": 9434,
	"./MK.svg": 51369,
	"./ML.svg": 8134,
	"./MM.svg": 70935,
	"./MN.svg": 66340,
	"./MO.svg": 44357,
	"./MP.svg": 1746,
	"./MQ.svg": 51139,
	"./MR.svg": 85040,
	"./MS.svg": 83489,
	"./MT.svg": 23582,
	"./MU.svg": 86159,
	"./MV.svg": 23484,
	"./MW.svg": 35677,
	"./MX.svg": 67402,
	"./MY.svg": 9371,
	"./MZ.svg": 28008,
	"./NA.svg": 23846,
	"./NC.svg": 68260,
	"./NE.svg": 11354,
	"./NF.svg": 26441,
	"./NG.svg": 75224,
	"./NI.svg": 73358,
	"./NL.svg": 90451,
	"./NO.svg": 35904,
	"./NP.svg": 47175,
	"./NR.svg": 17653,
	"./NU.svg": 90890,
	"./NZ.svg": 28093,
	"./OM.svg": 27521,
	"./PA.svg": 84048,
	"./PE.svg": 70908,
	"./PF.svg": 49935,
	"./PG.svg": 6206,
	"./PH.svg": 65081,
	"./PK.svg": 73706,
	"./PL.svg": 80565,
	"./PM.svg": 24308,
	"./PN.svg": 72519,
	"./PR.svg": 46419,
	"./PS.svg": 41250,
	"./PT.svg": 11469,
	"./PW.svg": 63118,
	"./PY.svg": 88664,
	"./QA.svg": 80103,
	"./RE.svg": 75046,
	"./RO.svg": 66636,
	"./RS.svg": 94920,
	"./RU.svg": 92982,
	"./RW.svg": 61012,
	"./SA.svg": 18553,
	"./SB.svg": 57802,
	"./SC.svg": 75643,
	"./SD.svg": 42580,
	"./SE.svg": 84565,
	"./SG.svg": 14087,
	"./SH.svg": 37520,
	"./SI.svg": 49761,
	"./SJ.svg": 38693,
	"./SK.svg": 99011,
	"./SL.svg": 24380,
	"./SM.svg": 95005,
	"./SN.svg": 40830,
	"./SO.svg": 3407,
	"./SR.svg": 78266,
	"./SS.svg": 97323,
	"./ST.svg": 35172,
	"./SV.svg": 90758,
	"./SX.svg": 2816,
	"./SY.svg": 49265,
	"./SZ.svg": 94722,
	"./TA.svg": 32916,
	"./TC.svg": 17302,
	"./TD.svg": 8889,
	"./TF.svg": 82331,
	"./TG.svg": 48138,
	"./TH.svg": 85341,
	"./TJ.svg": 93743,
	"./TK.svg": 31166,
	"./TL.svg": 40097,
	"./TM.svg": 27856,
	"./TN.svg": 89347,
	"./TO.svg": 51410,
	"./TR.svg": 52279,
	"./TT.svg": 67337,
	"./TV.svg": 87659,
	"./TW.svg": 68602,
	"./TZ.svg": 35359,
	"./UA.svg": 40075,
	"./UG.svg": 32645,
	"./UM.svg": 87775,
	"./UN.svg": 32428,
	"./US.svg": 61305,
	"./UY.svg": 41763,
	"./UZ.svg": 80272,
	"./VA.svg": 19806,
	"./VC.svg": 37532,
	"./VE.svg": 32146,
	"./VG.svg": 46064,
	"./VI.svg": 63414,
	"./VN.svg": 42630,
	"./VU.svg": 79586,
	"./WF.svg": 32002,
	"./WS.svg": 92271,
	"./XK.svg": 25906,
	"./XX.svg": 30449,
	"./YE.svg": 33043,
	"./YT.svg": 78322,
	"./ZA.svg": 70738,
	"./ZM.svg": 36630,
	"./ZW.svg": 99340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2059;